// extracted by mini-css-extract-plugin
export var growableInput = "_8g-0";
export var tagContainer = "_8g-2";
export var textInput = "_8g-1";